
import Vue from 'vue';
import Component from 'vue-class-component';
import { _APP_STORE } from '@/core/values/app.values';
import { MEETINGS_STORE } from '@/meetings/store/meetings.store';
import { COURSE_EVENTS } from '@/content/values/events';
import KEYS from '@/values/keys';
import { ACTIVE_TRANSPARENCY_EVENT, INACTIVE_TRANSPARENCY_EVENT, RESET_TRANSPARENCY_EVENT } from '@/content/values/ed-presentation-mode.values';

@Component({
  name: 'ed-toggle-transparency'
})
export default class EdToggleTransparency extends Vue {
  
  public switchToggle = true;

  get currentMeetingData() {
    return this.$store.state.MeetingsStore.currentMeetingData;
  }

  get currentPresentationSection() {
    return this.$store.state.MeetingsStore.currentPresentationSection.current;
  }

  get switchToggleTitle() {
    return this.switchToggle ? `${this.$i18n.t('menu.onTransparencyToggle')}` : `${this.$i18n.t('menu.offTransparencyToggle')}`;
  }
  
  get isPublisher() : boolean {
    return this.$store.state.AuthStore.role === KEYS.ROLES.PUBLISHER;
  }

  get isWhiteboardTransparency() : boolean {
    return this.$store.state.MeetingsStore.isWhiteboardTransparency;
  }

  get isTransparencyManually() : boolean {
    return this.$store.state.MeetingsStore.isTransparencyManually;
  }

  get isInitialWhiteboardTransparency() : boolean {
    return this.$store.state.MeetingsStore.isInitialWhiteboardTransparency;
  }

  get isBoardSectionHomework() : boolean {
    return this.$store.state.CourseStore.isBoardSectionHomework;
  }

  private onChangeTransparency(isManually : boolean = true) : void {
    this.$store.commit(MEETINGS_STORE.MUTATIONS.UPDATE_WHITEBOARD_TRANSPARENCY, this.switchToggle);
    this.$store.commit(MEETINGS_STORE.MUTATIONS.UPDATE_IS_TRANSPARENCY_MANUALLY, isManually);
    if(!this.switchToggle){
      this.$edEventBus.$emit(COURSE_EVENTS.SEND_TRANSPARENT_WHITEBOARD);
      if(this.isBoardSectionHomework){
        this.$store.commit(MEETINGS_STORE.MUTATIONS.UPDATE_CURRENT_BOARD_USER, {
          isTeacher: true,
          sectionId: this.currentPresentationSection.sectionId,
          fullName: this.$t('myContent.teacher')
        });
      }
    } else {
      this.$store.commit(MEETINGS_STORE.MUTATIONS.UPDATE_CURRENT_BOARD_USER, {});
    }
  }

  private inactivateTransparency() : void {
    if(this.isPublisher){
      this.switchToggle = false;
      this.onChangeTransparency(this.isTransparencyManually);
    }
  }

  private setTransparencyState() : void {
    if(this.isInitialWhiteboardTransparency){
      this.$store.commit(MEETINGS_STORE.MUTATIONS.UPDATE_INITIAL_WHITEBOARD_TRANSPARENCY, false);
      this.onChangeTransparency();
      return;
    }
    this.switchToggle = this.isWhiteboardTransparency;
  }

  private activeTransparency() : void {
    this.switchToggle = true;
    this.onChangeTransparency(this.isTransparencyManually);  
  }

  private resetTransparency() : void {
    this.$store.commit(MEETINGS_STORE.MUTATIONS.UPDATE_INITIAL_WHITEBOARD_TRANSPARENCY, true);
    this.switchToggle = true;
    this.onChangeTransparency(true); 
  }

  mounted() {
    this.$store.commit(MEETINGS_STORE.MUTATIONS.UPDATE_INITIAL_WHITEBOARD_TRANSPARENCY, true);
    this.setTransparencyState();
    this.$edEventBus.$on(ACTIVE_TRANSPARENCY_EVENT, this.activeTransparency);
    this.$edEventBus.$on(INACTIVE_TRANSPARENCY_EVENT, this.inactivateTransparency);
    this.$edEventBus.$on(RESET_TRANSPARENCY_EVENT, this.resetTransparency);

  }

  beforeDestroy() {
    this.$edEventBus.$off(ACTIVE_TRANSPARENCY_EVENT, this.activeTransparency);
    this.$edEventBus.$off(INACTIVE_TRANSPARENCY_EVENT, this.inactivateTransparency);
    this.$edEventBus.$off(RESET_TRANSPARENCY_EVENT, this.resetTransparency);

  }
}